import React, { memo } from 'react'
import classNames from 'classnames'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { Maybe } from 'types/graphqlTypes'

export interface ICarrierOptionStatusDotProps {
  showLabel: boolean
  status: Maybe<string>
}

const useCarrierOptionStatusDotStyles = makeStyles(theme => ({
  statusDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    marginRight: theme.spacing(1),
    borderWidth: '2px',
    borderStyle: 'solid',
    '&.available': {
      background: brandColors.green2,
      borderColor: brandColors.green2,
    },
    '&.unavailable': {
      background: brandColors.white,
      borderColor: brandColors.coolGray4,
    },
  },
  statusRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },
}))

const CarrierOptionStatusDot = memo<ICarrierOptionStatusDotProps>(({ showLabel, status }) => {
  const classes = useCarrierOptionStatusDotStyles()
  const isAvailable = status === null || status === 'accepted'

  return (
    <div className={classes.statusRow}>
      <div
        data-test='option-status-dot'
        className={classNames(classes.statusDot, isAvailable ? 'available' : 'unavailable')}
      />
      {showLabel && (
        <Typography variant='subtitle1' component='div'>
          {isAvailable ? 'Available' : 'Unavailable'}
        </Typography>
      )}
    </div>
  )
})

export default CarrierOptionStatusDot
